import { PaymentTypes } from '@ads-bread/shared/bread/codecs';

type DisclosureConfig = {
  disclosureName: string;
  requiresChecksum: boolean;
  checksumKey?: string;
};

export const REQUIRED_DISCLOSURES: Record<PaymentTypes, DisclosureConfig[]> = {
  INSTALLMENTS: [
    { disclosureName: 'loan-agreement', requiresChecksum: true },
    { disclosureName: 'auto-enroll', requiresChecksum: true },
    { disclosureName: 'credit-score-notice', requiresChecksum: false },
    { disclosureName: 'tila', requiresChecksum: false },
    {
      disclosureName: 'E_SIGN',
      requiresChecksum: true,
      checksumKey: 'loan-agreement', // There is no checksum exposed for this. Keeping existing logic and reusing loan-agreement's checksum
    },
  ],
  SPLITPAY: [
    { disclosureName: 'loan-agreement-sp', requiresChecksum: true },
    { disclosureName: 'credit-score-notice', requiresChecksum: false },
    { disclosureName: 'checkout-auto-enroll-sp', requiresChecksum: false },
    { disclosureName: 'payment-full-terms', requiresChecksum: false },
    {
      disclosureName: 'E_SIGN',
      requiresChecksum: true,
      checksumKey: 'loan-agreement-sp', // There is no checksum exposed for this. Keeping existing logic and reusing loan-agreement's checksum
    },
  ],
  HYBRID_LINE_OF_CREDIT: [
    { disclosureName: 'loan-agreement-hyloc', requiresChecksum: true },
    { disclosureName: 'credit-score-notice', requiresChecksum: false },
    { disclosureName: 'tila-hyloc', requiresChecksum: false },
    {
      disclosureName: 'E_SIGN',
      requiresChecksum: true,
      checksumKey: 'loan-agreement-hyloc', // There is no checksum exposed for this. Keeping existing logic and reusing loan-agreement's checksum
    },
  ],
};
